<template>
  <div>
    <default-modal
      ref="box"
      :title="title"
      :modalWidth="600"
      :confirmBtn="false"
      :cancleBtn="true"
      :cancleTxt="`关闭`"
    >
      <div class="content">
        <div class="_blue">
          我想把我通行证内的网吧ID（服务器）转移到别人的通行证下
        </div>
        <div class="_con">
          <p>
            1、将接收人提供的接收码填写到下方输入框，然后“保存接收码”。
          </p>
          <p>
            2、远程到每台服务器 > 基本设置 >
            网吧转移，输入“接收码”，点击转移即可。
          </p>
          <p>注1：如果网吧内有多台服务器，只需主服务器转移一次。</p>
          <p>注2：网吧转出后无法撤销，请谨慎操作。</p>
        </div>
        <div class="receiveCode">
          <input
            type="text"
            v-model="receiverCode"
            placeholder="请输入接收人提供的接收码"
          />
          <a href="#" @click.prevent="toSave" class="blue-btn">保存接收码</a>
        </div>
      </div>
    </default-modal>
  </div>
</template>

<script>
import DefaultModal from '_c/modals/defaultModal'
import { getTransferCnt, saveReceiveCode } from '@/requests/bar'
export default {
  name: 'barModals',
  components: {
    DefaultModal,
  },
  data() {
    return {
      title: '转出网吧',
      receiverCode: '',
      barIds: [],
    }
  },
  computed: {},
  mounted() {
    window.$modal.sendBarModal = {}
    window.$modal.sendBarModal.show = ({ barIds }) => {
      this.barIds = barIds
      this.init()
    }
    //监听键盘按键事件
    let self = this
    this.$nextTick(function() {
      document.addEventListener('keyup', function(e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          self.$refs.box.hide()
        }
      })
    })
  },
  methods: {
    init() {
      this.receiverCode = ''
      this.$refs.box.show()
    },
    async toSave() {
      console.log(this.barIds)
      this.$refs.box.clearWrong()
      if (this.receiverCode.trim() === '') {
        return this.$refs.box.setWrong('请输入接收码')
      }
      let res = await getTransferCnt({
        passportKey: this.receiverCode,
        barIds: JSON.stringify(this.barIds),
      })
      if (res.code == 200) {
        window.$Message.show({
          title: '确认转出网吧',
          type: 'info',
          msg: res.msg,
          cancleBtn: true,
          confirmFn: () => {
            this.saveCode()
            window.$Message.hide()
          },
        })
      } else {
        this.$refs.box.setWrong(res.msg)
      }
    },
    async saveCode() {
      let res = await saveReceiveCode({
        passportKey: this.receiverCode,
      })
      if (res.code == 200) {
        this.$refs.box.hide()
        window.$msg({
          showClose: true,
          type: 'success',
          message: '转移成功',
        })
      } else {
        this.$refs.box.setWrong(res.msg)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '_style/msgbox/_msgBox.scss';
@import '_style/_color.scss';

.content {
  padding: 0 20px;
  margin-top: 10px;

  ._blue {
    font-size: 14px;
    color: $blue;
    margin-bottom: 20px;
    text-align: left;
  }
  ._con {
    p {
      line-height: 20px;
      color: $gray-word;
      text-align: left;
    }
  }
  .receiveCode {
    margin: 25px 0 10px 0;
    input {
      width: 300px;
      height: 30px;
      border: 1px solid rgba(230, 230, 230, 1);
      padding-left: 10px;
    }
    a {
      width: 100px;
      height: 30px;
      padding: 0;
      text-align: center;
      line-height: 30px;
      color: #fff;
    }
  }
}
</style>
